function getQueryParams() {
  const params = {};
  const parser = new URL(window.location.href);
  const queryString = parser.search.slice(1);
  const pairs = queryString.split('&');

  for (const pair of pairs) {
    if (pair) {
      const [key, value] = pair.split('=');
      params[decodeURIComponent(key)] = decodeURIComponent(value || '');
    }
  }

  return params;
}
export default getQueryParams;
